import { Button } from '@frontend/ui';
import { useRouteError } from 'react-router';

export function ErrorBoundary() {
  const error = useRouteError();
  const message = error instanceof Error ? error.message : 'Unexpected error';

  return (
    <div role="alert" className="p-8">
      <h2 className="text-xl font-semibold">Something went wrong</h2>
      <p className="text-text-secondary mb-4">{message}</p>
      <Button
        onClick={() => {
          globalThis.location.reload();
        }}
      >
        Try again
      </Button>
    </div>
  );
}
